import * as React from 'react';
import { MenuItem } from 'lib/types';
import { Link } from 'gatsby';
import ExternalLink from '../ExternalLink';
import * as styles from './FooterLink.module.scss';

type FooterLinkProps = {
    item: MenuItem;
    prefix: string;
};

function FooterLink({
    item: { to, external, label, boldLabel },
    prefix,
}: FooterLinkProps) {
    const fullLabel = (
        <>
            {label}
            {boldLabel ? (
                <span className={styles.boldLabel}> {boldLabel}</span>
            ) : null}
        </>
    );

    const isExternal =
        external || to?.startsWith('http') || to?.startsWith('//');

    if (isExternal) {
        /* eslint-disable react/no-danger,jsx-a11y/control-has-associated-label */
        return <ExternalLink href={to}>{fullLabel}</ExternalLink>;
    }

    return <Link to={`${prefix}${to}`}>{fullLabel}</Link>;
}

export default FooterLink;
